// extracted by mini-css-extract-plugin
export default {"main":"Modal_main__H1OQK","headerWrap":"Modal_headerWrap__W1Um3","bodyWrap":"Modal_bodyWrap__8QDZt","footerWrap":"Modal_footerWrap__sQ700"};